module.exports = __webpack_public_path__ + "buyer-1.jpg?83cfe3e2e54996898b0754c7617a6a32";